export default "__VITE_ASSET__73314ace__"